<template>
  <div class="orders-checker">
    <div class="main">
      <el-card
        v-if="!result"
        class="box-card margin-b-20"
      >
        <h2>Verificador de Abonos</h2>
        <p>Por favor ingresa el nuemero IUT que se
        encuentra ubicado en la parte posterior del sobre.</p>
        <el-form
          @submit.native.prevent="onSubmit"
        >
          <el-form-item>
            <el-input
              v-model="code"
              placeholder="Código de boleto"
            />
          </el-form-item>
          <el-row :gutter="10">
            <el-col :span="12">
              <router-link :to="{name:'invoice'}">
                <el-button>Salir</el-button>
              </router-link>
            </el-col>
            <el-col :span="12">
              <el-button
                :disabled="submitting"
                type="primary"
                native-type="submit">Verificar
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
      <el-card
        v-else
        class="box-card margin-b-20"
      >
        <div
          v-if="order.status === 'delivered'"
          class="activated">
          <h2 >Código Activado</h2>
          <p>La tarjeta fue activada con los siguientes datos:</p>
          <table>
            <tr>
              <td class="label">Fecha de activación:</td>
              <td class="value">{{ order.updatedAt }}</td>
            </tr>
            <!-- <tr>
            <td class="label">Cliente:</td>
            <td class="value">{{ order.clientName }}</td>
          </tr>
          <tr>
            <td class="label">Teléfono:</td>
            <td class="value">{{ order.clientPhone }}</td>
          </tr>
          <tr>
            <td class="label">Correo electrónico:</td>
            <td class="value">{{ order.clientEmail }}</td>
          </tr>
          <tr>
            <td class="label">#IUT:</td>
            <td class="value">{{ order.iut }}</td>
          </tr> -->
            <!-- <tr>
              <td class="label">Abono:</td>
              <td class="value">{{ order.payment }}</td>
            </tr> -->
          </table>

        </div>
        <div
          v-else
          class="unactivated"
        >
          <h2>Código no activado</h2>
          <p>El boleto no ha sido activado y puede ser utilizado.</p>
        </div>

        <el-row :gutter="10">
          <el-col :span="12">
            <router-link :to="{name:'invoice'}">
              <el-button>Salir</el-button>
            </router-link>
          </el-col>
          <el-col :span="12">
            <el-button
              type="primary"
              @click="resetForm">Verificar Otro
            </el-button>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>

import http from '@/services/http.service'

/**
   * 'OrdersChecker' Component
   * @version 1.0.0
   * @author Fernando Torres
   * @copyright Marciano Studio S.C., 2018
   */
export default {
  name: 'OrdersChecker',
  data () {
    return {
      iut: '',
      submitting: false,
      order: {},
      result: false
    }
  },
  methods: {
    resetForm () {
      this.result = false
      this.iut = null
    },
    onSubmit () {
      let loader = this.$loading()
      this.submitting = true
      http.get('codes', {
        params: {
          'filters[where][code][eq]': this.code,
          limit: 1
        }
      }).then(response => {
        loader.close()
        this.submitting = false
        if (response.data.pagination.total > 0) {
          this.order = response.data.items[0]
          this.result = true
        } else {
          this.$message.error('El numero de tarjeta no está activado o no existe')
        }
      })
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>

.orders-checker{
  width: 100vw;
  height: 100vh;
      background-image: url(~/static/5c2523aa4fdbba1f26bf1750_master.jpg);
    background-position: center center;
    background-size: cover;
}

  h2 {
    padding: 0;
    margin: 0 0 10px 0;
    font-family: Michelin;
    font-size: 14px;
    color: #3a3a3a;
  }

  p {
    font-weight: 300;
  }

  table {
    margin: 20px 0;
    border-collapse: collapse;
    td {
      padding: 10px;
      &.label {
        background-color: #f5f5f5;
        text-align: right;
        font-weight: 600;
      }
    }
  }

  .close-btn {
    float: right;
    text-decoration: none;
    font-size: 20px;
    color: #444;
    :visited {
      color: #444;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/orders-checker.vue